import { AxiosResponse } from "axios";

import client from "../client";
import { getProfileConfig } from "./getProfileConfig";
import { GetProfileResponse } from "./types";

const getProfile = async ({
  authorization,
  origin,
}: {
  authorization: string | undefined;
  origin?: string;
}): Promise<AxiosResponse<GetProfileResponse>> => {
  return await client({ ...getProfileConfig(authorization, origin) });
};

export default { getProfile };
